export default __webpack_public_path__ + "static/media/share.0eb04b3b.svg";